import { render } from "./EditProfileForm.vue?vue&type=template&id=22a50e4b&scoped=true"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"

import "@/Common/Styles/editProfileForm.scss?vue&type=style&index=0&id=22a50e4b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a50e4b"]])

export default __exports__